import { render } from "./StudyCard.vue?vue&type=template&id=a8276a1c&scoped=true&ts=true"
import script from "./StudyCard.ts?vue&type=script&lang=ts&external"
export * from "./StudyCard.ts?vue&type=script&lang=ts&external"

import "./StudyCard.scss?vue&type=style&index=0&id=a8276a1c&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8276a1c"]])

export default __exports__